module.exports = __webpack_public_path__ + "static/media/ticket_bg2.9af71b08.png";